import { create } from 'zustand';
import { api } from '../lib/api';

/**
 * Platform (Custel operatör personeli) oturum store'u.
 *
 * Müşteri (tenant OWNER) tarafından TAMAMEN ayrıdır — `auth.store.ts` ile
 * karışmaz. Platform cookie'si (`platform_access_token`, httpOnly) login
 * sırasında set edilir; bu store sadece `GET /platform/staff/me` ile
 * oturumu doğrular ve personel kimliğini bellekte tutar.
 */
export type PlatformStaffRole = 'OPS_ADMIN' | 'SUPPORT';

export interface PlatformStaff {
  staffId: string;
  email: string;
  name: string;
  /** Sprint 35 — yetki seviyesi; provisioning UI bunu kontrol eder. */
  role: PlatformStaffRole;
}

interface PlatformMeResponse {
  staffId: string;
  email: string;
  name: string;
  role: PlatformStaffRole;
  isPlatform: true;
}

interface PlatformState {
  staff: PlatformStaff | null;
  isLoading: boolean;
  hasChecked: boolean;

  fetchPlatformSession: () => Promise<void>;
  setStaff: (staff: PlatformStaff | null) => void;
  logout: () => Promise<void>;
}

export const usePlatformStore = create<PlatformState>((set) => ({
  staff: null,
  isLoading: false,
  hasChecked: false,

  async fetchPlatformSession() {
    set({ isLoading: true });
    try {
      const me = await api.get<PlatformMeResponse>('/platform/staff/me');
      set({
        staff: { staffId: me.staffId, email: me.email, name: me.name, role: me.role },
        isLoading: false,
        hasChecked: true,
      });
    } catch {
      // 401 (cookie yok/expired) dahil → oturum yok.
      set({ staff: null, isLoading: false, hasChecked: true });
    }
  },

  setStaff(staff) {
    set({ staff, hasChecked: true });
  },

  async logout() {
    try {
      await api.post('/auth/logout');
    } catch {
      // ignore — yine de yerel state'i temizle.
    }
    set({ staff: null });
    // Hard redirect: tüm in-memory query cache + state temiz başlasın.
    if (typeof window !== 'undefined') {
      window.location.assign('/giris');
    }
  },
}));
